// extracted by mini-css-extract-plugin
module.exports = {"component":"booking-price-details_component__mi1DQ","contentWrapper":"booking-price-details_contentWrapper___a2QI"};